import { Component, OnInit } from "@angular/core";
declare var $: any;

@Component({
    selector: "app-emailVerify",
    templateUrl: "./emailVerify.component.html",
    providers: []
})
export class EmailVerifyComponent implements OnInit {
    public loading = true;
    public filterQuery = "";
    public rowsOnPage = 10;
    public sortBy = "name";
    public sortOrder = "asc";

    constructor(

    ) { }


    ngOnInit(): void {
    }
}



// WEBPACK FOOTER //
// ./src/app/core/pages/admin/emailVerify/emailVerify.component.ts